import React from "react"

interface SeperatorProps {
  className?: string
}

const Seperator: React.FC<SeperatorProps> = ({
  className
}) => {

  const setClassName = className ? `${className} seperator` : 'seperator'

  return (
    <div className={setClassName}></div>
  )
}

export { Seperator }
